import {
  portableTextBlockSchema,
  sanityContentImageSchema,
  sanityContentVideoSchema,
  sanityImageObjectSchema,
} from "@modules/common/cms/sanityDto"
import { z } from "zod"

export const CrossFitEventSchema = z.object({
  title: z.string(),
  subtitle: z.string().optional(),
  id: z.object({
    _type: z.literal("slug"),
    current: z.string(),
  }),
  place: z.string().optional(),
  card: z
    .object({
      title: z.string().optional(),
      subtitle: z.string().optional(),
    })
    .optional(),
  description: z
    .array(
      z.union([
        portableTextBlockSchema,
        sanityContentImageSchema,
        sanityContentVideoSchema,
      ]),
    )
    .optional(),
  date: z.object({
    start: z.string(),
    end: z.string(),
  }),
  prod: z
    .object({
      box_id: z.string(),
      offer_id: z.string(),
      default_guest: z.string().optional(),
    })
    .optional(),
  demo: z
    .object({
      box_id: z.string(),
      offer_id: z.string(),
      default_guest: z.string().optional(),
    })
    .optional(),
  dev: z
    .object({
      box_id: z.string(),
      offer_id: z.string(),
      default_guest: z.string().optional(),
    })
    .optional(),
  plan: z
    .object({
      uri: z.string().url(),
      cache: z.boolean(),
      expiration: z.number().optional(),
    })
    .optional(),
  crossfit_logo: sanityImageObjectSchema.optional(),
  logo: sanityImageObjectSchema.optional(),
  logo_circle: sanityImageObjectSchema.optional(),
  background: z
    .object({
      DARK: sanityImageObjectSchema,
      LIGHT: sanityImageObjectSchema,
    })
    .optional(),
  leaderboards: z
    .array(
      z.object({
        title: z.string(),
        url: z.string().url(),
      }),
    )
    .optional(),
  schedules: z
    .array(
      z.object({
        title: z.string(),
        url: z.string().url(),
      }),
    )
    .optional(),
  watch_live: z
    .array(
      z.object({
        title: z.string(),
        url: z.string().url(),
        date: z.string().optional(),
      }),
    )
    .optional(),
  cta: z
    .object({
      tickets: z.string().url().optional(),
      website: z.string().url().optional(),
    })
    .optional(),
  badge_code: z.string().optional(),
  coords: z
    .object({
      lat: z.number(),
      lng: z.number(),
    })
    .optional(),
})

export type CrossFitEventDto = z.infer<typeof CrossFitEventSchema>
